/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as a from "react";
import { GridContext as n } from "../../utils/GridContext.mjs";
import { ColumnDraggable as t } from "../../drag/ColumnDraggable.mjs";
const o = (r) => {
  const e = a.useContext(n);
  return e.dragLogicRef.current.pressHandler && /* @__PURE__ */ a.createElement(
    t,
    {
      ariaRowIndex: r.ariaRowIndex,
      pressHandler: e.dragLogicRef.current.pressHandler,
      dragHandler: e.dragLogicRef.current.dragHandler,
      releaseHandler: e.dragLogicRef.current.releaseHandler,
      dragClue: e.dragLogicRef.current.dragClue,
      headerRef: e.headerElementRef,
      containerRef: e.containerElementRef
    },
    r.children
  ) || /* @__PURE__ */ a.createElement("tr", { className: r.className, role: "row", "aria-rowindex": r.ariaRowIndex }, r.children);
};
export {
  o as HeaderRowDraggable
};
